import { render, staticRenderFns } from "./classInfo.vue?vue&type=template&id=afb58f84&scoped=true&"
import script from "./classInfo.vue?vue&type=script&lang=js&"
export * from "./classInfo.vue?vue&type=script&lang=js&"
import style0 from "./classInfo.vue?vue&type=style&index=0&id=afb58f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb58f84",
  null
  
)

export default component.exports